module.exports = __webpack_public_path__ + "img/logo.756e6d99.png";